import type { SubscriptionStatus } from '../../shared/api/types';

export function formatPrice(cents: number, currency: string): string {
  return new Intl.NumberFormat('es', { style: 'currency', currency, minimumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100);
}

export const STATUS_LABELS: Record<SubscriptionStatus, string> = {
  pending: 'Pendiente de activación',
  trialing: 'En prueba',
  trial_expired: 'Prueba terminada',
  active: 'Activa',
  grace: 'En periodo de gracia',
  past_due: 'Suspendida (pago vencido)',
  courtesy: 'Cortesía',
  canceled: 'Cancelada',
};

export const INTERVAL_LABELS: Record<string, string> = { month: 'Mensual', quarter: 'Trimestral', semester: 'Semestral', year: 'Anual' };
export const INTERVAL_PERIOD: Record<string, string> = { month: 'el siguiente mes', quarter: 'el siguiente trimestre', semester: 'el siguiente semestre', year: 'el siguiente año' };

/** Una suscripción que ya no permite modificar datos (la Iglesia queda en solo lectura). */
export const isLapsed = (status: SubscriptionStatus) => status === 'pending' || status === 'trial_expired' || status === 'past_due' || status === 'canceled';

export const daysLabel = (days: number) => (days === 1 ? '1 día' : `${days} días`);
